import React, { useState } from 'react';
import {
  Form,
  Modal,
  Input,
  Button,
  Row,
  Spin,
} from 'antd';
import { login } from 'api/usuarios/auth';
import PropTypes from 'prop-types';
import { LockOutlined, MailOutlined } from '@ant-design/icons';
import FormSubmitControls from 'components/FormSubmitControls';

const ModalLogin = ({ callback, visible, setVisible }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    const loginData = await login(values);
    if (loginData) {
      setLoading(false);
      setVisible(false);
      callback(loginData);
      form.resetFields();
    }
    setLoading(false);
  };

  const rules = {
    email: [{ required: true }],
    password: [{ required: true }],
  };

  return (
    <Modal
      footer={null}
      closable={false}
      visible={visible}
      onCancel={() => setVisible(false)}
      title={(
        <Row justify="space-between">
          Inicio de Sesión
          <FormSubmitControls onCancel={() => setVisible(false)} />
        </Row>
      )}
      keyboard={!loading}
    >
      <Spin spinning={loading} tip="Cargando...">
        <Form
          name="login-form"
          layout="vertical"
          form={form}
          onFinish={onFinish}
          hideRequiredMark
          scrollToFirstError
        >
          <Form.Item
            name="email"
            rules={rules.email}
            label="Correo"
            hasFeedback
          >
            <Input prefix={<MailOutlined />} />
          </Form.Item>
          <Form.Item
            name="password"
            rules={rules.password}
            label="Contraseña"
            hasFeedback
          >
            <Input.Password prefix={<LockOutlined />} />
          </Form.Item>

          <Form.Item style={{ marginBottom: 0 }}>
            <Button
              className="auth-button"
              htmlType="submit"
              shape="round"
              disabled={loading}
              block
            >
              Iniciar sesión
            </Button>
          </Form.Item>
        </Form>
      </Spin>
    </Modal>
  );
};

ModalLogin.propTypes = {
  callback: PropTypes.func.isRequired,
  visible: PropTypes.bool,
  setVisible: PropTypes.func.isRequired,
};

ModalLogin.defaultProps = {
  visible: false,
};

export default ModalLogin;
